// Gestion du consentement cookies — implémentation native légère (sans dépendance).
// Note sécurité : on ne stocke ici QUE des préférences de cookies non sensibles
// (deux booléens + un horodatage). Aucune donnée personnelle ni secret n'est
// concerné, donc localStorage est adapté et sans risque en cas de XSS.
export const CONSENT_KEY = "cookie_consent_v1";
export const CONSENT_MAX_AGE_MS = 15552000000; // ~6 mois (180 jours)

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (!c || typeof c.ts !== "number") return null;
    if (Date.now() - c.ts > CONSENT_MAX_AGE_MS) return null;
    return { analytics: !!c.analytics, external: !!c.external, ts: c.ts };
  } catch {
    return null;
  }
}

export function saveConsent({ analytics, external }) {
  const c = { analytics: !!analytics, external: !!external, ts: Date.now() };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(c));
  } catch (e) {
    if (process.env.NODE_ENV === "development")
      console.error("consent: échec d'écriture localStorage", e);
  }
  return c;
}

// Arrête PostHog et supprime ses cookies / localStorage lorsque le consentement est retiré.
export function clearAnalyticsStorage() {
  try {
    if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
      window.posthog.opt_out_capturing();
      if (typeof window.posthog.reset === "function") window.posthog.reset(true);
    }
    Object.keys(localStorage).forEach((k) => {
      if (k.startsWith("ph_") || k.indexOf("posthog") !== -1) localStorage.removeItem(k);
    });
    document.cookie.split(";").forEach((ck) => {
      const name = ck.split("=")[0].trim();
      if (name.startsWith("ph_") || name.indexOf("posthog") !== -1) {
        const expire = "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        document.cookie = name + expire;
        document.cookie = name + expire + ";domain=." + window.location.hostname;
      }
    });
  } catch (e) {
    if (process.env.NODE_ENV === "development")
      console.error("consent: échec du nettoyage analytics", e);
  }
}

// Applique l'état de consentement aux traceurs réels.
export function applyConsent(consent) {
  if (!consent) return;
  if (consent.analytics) {
    if (typeof window.__initAnalytics === "function") window.__initAnalytics();
    if (window.posthog && typeof window.posthog.opt_in_capturing === "function") {
      try {
        window.posthog.opt_in_capturing();
      } catch (e) {
        if (process.env.NODE_ENV === "development")
          console.error("consent: échec opt_in PostHog", e);
      }
    }
  } else {
    clearAnalyticsStorage();
  }
}
